import { LegalPageLayout, FAQSections } from "../components/LegalPageLayout";

export default function FAQ() {
  return (
    <LegalPageLayout pageKey="faq">
      <FAQSections />
    </LegalPageLayout>
  );
}
